import { DatePipe, NgIf, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { DsIconComponent } from '@design-system/ds-icon/component/ds-icon.component';
import { DsTextComponent } from '@design-system/ds-text/component/ds-text.component';
import { ServiceRequestFlag } from '@modals/service-request-flags/interfaces/service-request-flag.interface';

@Component({
  selector: 'app-resolved-flags-table',
  templateUrl: './resolved-flags-table.component.html',
  styleUrls: ['./resolved-flags-table.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, DatePipe, UpperCasePipe, MatTableModule, DsIconComponent, DsTextComponent],
})
export class ResolvedFlagsTableComponent {
  @Input() flags: ServiceRequestFlag[] = [];

  readonly displayedColumns: string[] = ['category', 'createdBy', 'resolvedBy', 'reason', 'resolutionNote'];
}
